import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInsertTable = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10 17.5L10 2.5M17.5 10L2.5 10M7.83333 17.5H12.1667C14.0335 17.5 14.9669 17.5 15.68 17.1367C16.3072 16.8171 16.8171 16.3072 17.1367 15.68C17.5 14.9669 17.5 14.0335 17.5 12.1667V7.83333C17.5 5.96649 17.5 5.03307 17.1367 4.32003C16.8171 3.69282 16.3072 3.18289 15.68 2.86331C14.9669 2.5 14.0335 2.5 12.1667 2.5H7.83333C5.96649 2.5 5.03307 2.5 4.32003 2.86331C3.69282 3.18289 3.18289 3.69282 2.86331 4.32003C2.5 5.03307 2.5 5.96649 2.5 7.83333V12.1667C2.5 14.0335 2.5 14.9669 2.86331 15.68C3.18289 16.3072 3.69282 16.8171 4.32003 17.1367C5.03307 17.5 5.96649 17.5 7.83333 17.5Z",
		stroke: "#71717A",
		strokeWidth: 1.3,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgInsertTable);
export default ForwardRef;
